module.exports = __webpack_public_path__ + "img/sdg_en_(1).21d54bfd.png";